var map = {
	"./close.svg": "864a",
	"./cloud.svg": "f620",
	"./down.svg": "1a4e",
	"./edit.svg": "2fb0",
	"./experience.svg": "63bb",
	"./home.svg": "0331",
	"./landline.svg": "091f",
	"./left.svg": "d6aa",
	"./lifeSaver.svg": "f62a",
	"./magic.svg": "8af5",
	"./mail.svg": "8ca3",
	"./mapMarker.svg": "03c1",
	"./occupa.svg": "6632",
	"./open.svg": "d494",
	"./phone.svg": "b470",
	"./photograph.svg": "14c9",
	"./quesMark.svg": "a0a5",
	"./right.svg": "6ffa",
	"./specifi.svg": "12c4",
	"./star.svg": "4e5a",
	"./steam.svg": "5a41",
	"./up.svg": "bc3e",
	"./user.svg": "d88a",
	"./wechat.svg": "2ba1",
	"./wordFile.svg": "f9e1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "19f5";